import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TokenService } from '../../../_services/token-service';
import { AuthJWTService } from '../auth.jwt.service';
import { AuthenticationService } from '../_services/authenticationService';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-authentication',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.scss']
})
export class AuthenticationComponent implements OnInit {

  authenticationInfo: FormGroup = this._authentication;
  counter = 3;
  currentYear: number = new Date().getFullYear();
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private service: AuthenticationService,
    private changeDetector: ChangeDetectorRef,
    private tokenService: TokenService,
    private authJWSService: AuthJWTService,
      ) { }
  
  ngOnInit(): void {
    const stateIDControl = this.authenticationInfo.get('stateID');
    stateIDControl.valueChanges.subscribe(() => {
      stateIDControl.patchValue(stateIDControl.value.toUpperCase(), { emitEvent: false });
    });
  }
  isSpanishlanguage() {
    return this.tokenService.gettempToken().formLanguage == "S"
  }

  verifyData() {
    let tblToken = this.tokenService.gettempToken();
    this.service.getAuthentication(tblToken.caseNumber, this.authenticationInfo.value.stateID).subscribe(data => {
      if (data.isStateIdExists == true) {
        this.authJWSService.setJWTRefreshToken(tblToken);
        // Magi
        if (tblToken.officialFormID == "470-5168" && tblToken.formLanguage == "EN") {
          this.tokenService.sendToken(tblToken);
          this.router.navigate(["client/forms/470_5168"]);
        }
        else if (tblToken.officialFormID == "470-5168" && tblToken.formLanguage == "S")
        {
          this.tokenService.sendToken(tblToken);
          this.router.navigate(["client/forms/470_5168/es"]);
        }
        //Non Magi
        else if (tblToken.officialFormID == "470-5482" && tblToken.formLanguage == "EN") {
          this.tokenService.sendToken(tblToken);
          this.router.navigate(["client/forms/470_5482"]);
        }
        else if (tblToken.officialFormID == "470-5482" && tblToken.formLanguage == "S") {
          this.tokenService.sendToken(tblToken);
          this.router.navigate(["client/forms/470_5482/es"]);
        }
        //RAC
        else if (tblToken.officialFormID == "470-5590" && (tblToken.formLanguage == "EN" || tblToken.formLanguage == "S")) {
          this.tokenService.sendToken(tblToken);
          this.router.navigate(["client/forms/470_5590"]);
        }
        else {
          this.router.navigate(["error"]);
        }
      }
      else {
        this.counter = this.counter - 1;
        this.changeDetector.detectChanges();
      }
    });
  }
 

  get _authentication(): FormGroup {
    return this.fb.group({
      stateID: []
    });
  }
}
